import { Play } from "lucide-react";
import { coverOf } from "@/lib/media";

export const CoverMedia = ({ item, className = "", playSize = "md" }) => {
  const c = coverOf(item);
  const base = `w-full h-full object-cover transition-transform duration-500 group-hover:scale-110 ${className}`;
  const btn = playSize === "sm" ? "h-9 w-9" : "h-14 w-14";
  return (
    <>
      {c.src ? <img src={c.src} alt={item?.title || ""} className={base} loading="lazy" />
        : c.video ? <video src={`${c.video}#t=0.5`} preload="metadata" muted playsInline className={base} />
        : <div className={`${base} bg-[#111]`} />}
      {c.kind !== "image" && (
        <span className="absolute inset-0 flex items-center justify-center pointer-events-none z-[1]" data-testid="cover-play-icon">
          <span className={`${btn} rounded-full bg-black/55 backdrop-blur-md border border-[#D4AF37]/60 flex items-center justify-center transition-transform duration-300 group-hover:scale-110`}>
            <Play className="text-[#D4AF37] fill-[#D4AF37] ml-0.5" size={playSize === "sm" ? 14 : 22} />
          </span>
        </span>
      )}
    </>
  );
};
